import { MainCategory } from './mainCategory.model';
import { AttributeModel } from './attribute.model'
export class SuperCategory {
    _id: string;
    categoryName: string;
    categoryDescription: string;
    sortOrder: number;
    status: string;
    categoryImageName: string;
    checkCategoryName: boolean;
    mainCategory: [MainCategory];
    count: number;
    superCatData: boolean;
    mainCatData: boolean;
    subCatData: boolean;
    brandCatData: boolean;
    collectionCatData: boolean;
    brandId: string;
    collectionId: string;
    promotionCatData: boolean;
    attribute: [AttributeModel];
    customizeMenu: boolean;
    urlLink: string;
}
